import type { Mission } from '../missions.ts'

export const nro: Mission = {
  id: "nro",
  name: "National Reconnaissance Office",
  short: "NRO",
  call: "Reconnaissance",
  kind: "subagency",
  parent: "dod",
  community: "intelligence",
  url: "https://www.nro.gov/",
  established: 1961,
  palette: {
    primary: "#204a93",
    secondary: "#2bb673",
    accent: "#faac56",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:NRO.svg",
  },
  motif: "orbit",
  mission: {
    text: "NRO develops, acquires, launches, and operates space-based assets and ground systems to see, hear, and sense threats around the world in real time.",
    url: "https://www.nro.gov/About-NRO/",
  },
  fact: {
    text: "First launched in 1960, the CORONA reconnaissance satellite program searched broad areas to capture imagery while orbiting high above the Earth.",
    url: "https://www.nro.gov/About-NRO/history/",
  },
  seal: {
    file: "public/seals/nro.png",
    source: "https://commons.wikimedia.org/wiki/File:NRO.svg",
  },
  identifier: {
    about: "https://www.nro.gov/About-NRO/",
    accessibility: "https://www.nro.gov/accessibility/",
    foia: "https://www.nro.gov/foia-home/",
    noFear: "https://www.nro.gov/no-fear-act/",
    oig: "https://www.nro.gov/nro-ig/",
    privacy: "https://www.nro.gov/privacy/",
  },
  media: {
    photos: [
      {
        file: "/media/nro-nrol85-launch.jpg",
        small: "/media/nro-nrol85-launch-sm.jpg",
        alt: "A Falcon 9 rocket lifts off before dawn from Vandenberg Space Force Base, its engine flame lighting billowing exhaust clouds against a dark sky.",
        title: "NROL-85 launch from Vandenberg Space Force Base, April 17, 2022",
        creator: "Michael Peterson, U.S. Space Force",
        source: "https://commons.wikimedia.org/wiki/File:NROL-85_mission_launches_from_Vandenberg_Space_Force_Base_(7146492).jpeg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
